import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const employeeSelector = ({ employee }: ReducerState) => employee;
export const employeeLoadingSelector = createSelector(
  employeeSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
